module.exports = __webpack_public_path__ + "img/Icon_home _going.a3a80cd1.svg";